import { render, staticRenderFns } from "./topup.vue?vue&type=template&id=6c13a62a&scoped=true&"
import script from "./topup.vue?vue&type=script&lang=ts&"
export * from "./topup.vue?vue&type=script&lang=ts&"
import style0 from "./topup.vue?vue&type=style&index=0&id=6c13a62a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c13a62a",
  null
  
)

export default component.exports